"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ModalContext_1 = require("../context/ModalContext");
const Modal = (props) => {
    const context = (0, react_1.useContext)(ModalContext_1.ModalContext);
    const modalRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (!modalRef.current) {
            return;
        }
        const resizeObserver = new ResizeObserver(() => {
            var _a;
            parent.postMessage({
                event: 'llm-modal-resize',
                payload: { height: (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight },
            });
        });
        resizeObserver.observe(modalRef.current);
        return () => {
            resizeObserver.disconnect();
        };
    }, []);
    const header = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("h5", { children: ["AI prompt ", context === null || context === void 0 ? void 0 : context.title] }), (0, jsx_runtime_1.jsx)("button", { onClick: props.close, type: "button", className: "close", "data-dismiss": "modal", children: (0, jsx_runtime_1.jsx)("span", { className: "bi bi-x-lg" }) })] }));
    if (props.displayStyle === 'modal') {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "modal modal-llm in", role: "dialog", tabIndex: -1, id: "admin_dialog_llm", style: { display: 'block' }, children: (0, jsx_runtime_1.jsx)("div", { className: "modal-dialog", children: (0, jsx_runtime_1.jsxs)("div", { className: "modal-content", children: [(0, jsx_runtime_1.jsx)("div", { className: "modal-header", children: header }), props.children] }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "modal-backdrop in" })] }));
    }
    else if (props.displayStyle === 'iframe') {
        return ((0, jsx_runtime_1.jsx)("div", { className: 'modal-llm', children: (0, jsx_runtime_1.jsxs)("div", { className: "modal-content", ref: modalRef, children: [(0, jsx_runtime_1.jsx)("div", { className: "modal-header", children: header }), props.children] }) }));
    }
};
exports.Modal = Modal;
